/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Project from '../model/entity/organisation/project';
import User from '../model/entity/organisation/user';
export default {
    namespaced: true,
    state: () => ({
        loginRedirectUrl: null,
        oauthLogin: false,
        project: null,
        projectSettings: [],
        refreshingToken: false,
        refreshToken: null,
        token: null,
        user: null,
        userSettings: [],
    }),
    mutations: {
        loginRedirectUrl(state, loginRedirectUrl) {
            state.loginRedirectUrl = loginRedirectUrl;
        },
        oauthLogin(state, oauthLogin) {
            state.oauthLogin = oauthLogin;
        },
        project(state, project) {
            state.project = project ? structuredClone(project.dto) : null;
        },
        projectSettings(state, settings) {
            state.projectSettings = settings;
        },
        refreshingToken(state, refreshingToken) {
            state.refreshingToken = refreshingToken;
        },
        refreshToken(state, refreshToken) {
            state.refreshToken = refreshToken;
        },
        token(state, token) {
            state.token = token;
        },
        user(state, user) {
            state.user = user ? structuredClone(user.dto) : null;
        },
        userSettings(state, settings) {
            state.userSettings = settings;
        },
    },
    actions: {},
    getters: {
        loginRedirectUrl(state) {
            if (!state.loginRedirectUrl) {
                return null;
            }
            return state.loginRedirectUrl;
        },
        oauthLogin(state) {
            return state.oauthLogin;
        },
        project(state) {
            if (!state.project) {
                return null;
            }
            return new Project(state.project);
        },
        projectSettings(state) {
            return state.projectSettings;
        },
        refreshingToken(state) {
            return state.refreshingToken;
        },
        refreshToken(state) {
            return state.refreshToken;
        },
        token(state) {
            return state.token;
        },
        user(state) {
            if (!state.user) {
                return null;
            }
            return new User(state.user);
        },
        userSettings(state) {
            return state.userSettings;
        },
    },
};
//# sourceMappingURL=authentication.js.map